import { useMutation, useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { showEmployeRequests, updateEmployeRequests } from '../../../../MyApi/hr/employerequests'


import PageHeader from '../../../../Components/UI/PageHeader'
import LoadingSpinner from '../../../../Components/UI/spinner'

import EmployeRequestsDetalis from '../../../../Components/hr/employrequests/employerequestsShow/employeRequestDetalis'
import { useState } from 'react'
import StatusModal from '../../../../Components/hr/employrequests/employerequestsShow/EditRequestModal'


const EmployeRequestShow = () => {
    const {id} =useParams()
    const [isModalOpen ,setIsModalOpen] = useState(false)
    const {data , isLoading ,refetch}= useQuery(["ShowEmployeRequests",id], ()=>showEmployeRequests(id))
     const employeRequest = data?.data||{}
    
    const  handelEditRequest =()=>{
     setIsModalOpen(true)
    }
    const closeModal=()=>{
      setIsModalOpen(false)
    }
    if(isLoading){ 
        return <LoadingSpinner/>
    }
    if(!data){
        return<div>no data available</div>
    } 
  return (
    <div>
        <PageHeader showEditRequest handelEditRequest={handelEditRequest} title="Empolyes Requests Detalis" showBack={true} />
        <EmployeRequestsDetalis  employeRequest={employeRequest} />
        {isModalOpen && <StatusModal id={id} closeModal={closeModal} refetch={refetch} />}
    </div>
  )
}

export default EmployeRequestShow